module.exports = __webpack_public_path__ + "static/media/zenodo-upload.f4d62915.png";